import { ComponentProps } from 'react'
import { Savings } from 'experiences/explore/Savings'
import { NextPage } from 'next'
import { StandardLayout } from 'shared/layout/StandardLayout'
import { getSEOServersideProps, PagePropsWrapper } from 'lib/routing/nextPageUtils'
import { ContentfulProducts } from 'parameters/products'
import { ProductConstraint } from 'services/ContentfulService/constraints'
import { fetchArticles } from 'services/ContentfulService/hooks/articles'
import { summarizeArticles } from 'services/ContentfulService/models/articles'

type Props = ComponentProps<typeof Savings>

const SavingsPage: NextPage<PagePropsWrapper<Props>> = ({ metaTags, pageProps }) => {
	return (
		<StandardLayout metaTags={metaTags}>
			<Savings articles={pageProps.articles} />
		</StandardLayout>
	)
}

export const getServerSideProps = getSEOServersideProps<Props>(async () => {
	const articles = await fetchArticles({ constraints: [ProductConstraint(ContentfulProducts.Savings)], count: 3 })

	return {
		articles: summarizeArticles(articles)
	}
})

export default SavingsPage
